export default class ShopCarousel extends HTMLElement {
    private embla: any = null
    private viewportEl: HTMLElement
    private prevButtonEl: HTMLElement | null = null
    private nextButtonEl: HTMLElement | null = null
    private dotsEl: HTMLElement | null = null

    constructor() {
        super()
        this.viewportEl = this.querySelector('.embla__viewport') as HTMLElement
        this.prevButtonEl = this.querySelector('[data-button-prev]')
        this.nextButtonEl = this.querySelector('[data-button-next]')
        this.dotsEl = this.querySelector('.embla__dots')

        this.prevButtonEl?.addEventListener('click', this.handlePrevClick.bind(this))
        this.nextButtonEl?.addEventListener('click', this.handleNextClick.bind(this))

        this.className = 'block lg:w-[calc(66.6vw-10px)] lg:ml-[-20px]'

        if (this.dotsEl) {
            this.dotsEl.querySelectorAll('[data-dot-button]').forEach((dot) => {
                if (dot) {
                    ;(dot as HTMLElement).addEventListener('click', this.handleDotClick.bind(this))
                }
            })
        }
    }

    connectedCallback() {
        if (this.viewportEl) {
            import('embla-carousel').then((EmblaCarousel) => {
                this.embla = EmblaCarousel.default(this?.viewportEl, {
                    loop: true,
                    align: 'start',
                })

                this.embla.on('select', () => this.updateDots())
                this.updateDots()
            })
        }
    }

    disconnectedCallback() {
        if (this.embla) {
            this.embla.destroy()
        }
    }

    handlePrevClick() {
        this.embla?.scrollPrev()
    }

    handleNextClick() {
        this.embla?.scrollNext()
    }

    handleDotClick(evt: MouseEvent) {
        const index = (evt.currentTarget as HTMLElement).getAttribute('data-index') as string
        if (index) {
            this.embla?.scrollTo(parseInt(index))
        }
    }

    private updateDots() {
        if (!this.dotsEl) return

        const dots = this.dotsEl.querySelectorAll('[data-dot-button]')
        const selectedIndex = this.embla?.selectedScrollSnap() || 0

        dots.forEach((dot, index) => {
            dot.classList.toggle('opacity-100', index === selectedIndex)
            dot.classList.toggle('opacity-50', index !== selectedIndex)
        })
    }
}

customElements.define('shop-carousel', ShopCarousel)
